import * as React from 'react';
import { CaretDownOutlined } from '@easyv/react-icons';
import classNames from 'classnames';
import { ConnectionLine } from './ConnectionLine';

export interface CollapseBoxProp {
  className?: string;
  titleClassName?: string;
  disable?: boolean; // 禁用展开
  panelClassName?: string;
  title: React.ReactNode;
  titleSuffix?: React.ReactNode;
  headerClassName?: string;
  collapseIconClassName?: string;
  titleExtra?: React.ReactNode;
  showContextBorder?: boolean;
  showConnectionLine?: boolean;
  children?: React.ReactNode;
  showDivider?: boolean;
  noStyle?: boolean; // true 表示不采用排版form.item用的左边距样式
  type?: 'area' | 'default'; // 'default' 只设置文字颜色; 'area' 用于自定义组件的一块渲染区域(hover会改变背景色)
  showChildren?: boolean;
}

export function CollapseBox({
  className,
  panelClassName = '',
  disable = false,
  title,
  titleSuffix,
  titleClassName,
  headerClassName,
  titleExtra,
  showChildren,
  collapseIconClassName = '',
  showContextBorder = false,
  showConnectionLine = false,
  noStyle = !showConnectionLine,
  showDivider = false,
  children,
  type = 'default',
}: CollapseBoxProp) {
  const [listOpen, setListOpen] = React.useState<boolean>(true);

  React.useEffect(() => {
    if (showChildren !== undefined) {
      setListOpen(showChildren);
    }
  }, [showChildren]);

  const getFinalClassName = () => {
    switch (type) {
      case 'default':
        return {
          wrapperClassName: '',
          titleClassName: 'text-baseText',
          panelClassName: '',
        };

      case 'area':
        return {
          wrapperClassName: 'py-1 hover:bg-bg0000001F',
          titleClassName: 'text-white px-3',
          panelClassName: 'px-3',
        };
    }
  };

  const finalClassName = getFinalClassName();

  return (
    <>
      <div
        className={classNames(
          className,
          finalClassName.wrapperClassName,
          showDivider && 'border-b border-b-FFFFFF0F',
        )}
      >
        <div
          className={classNames(
            'h-9 flex justify-between collapasebox-header',
            finalClassName.titleClassName,
            headerClassName,
            !disable && 'cursor-pointer',
          )}
          onClick={() => {
            !disable && setListOpen(!listOpen);
          }}
        >
          <div className={classNames('flex items-center w-full')}>
            {!disable && (
              <div
                className={classNames(
                  'flex items-center justify-center text-content4 w-4 h-4 shrink-0',
                )}
              >
                <CaretDownOutlined
                  className={classNames('text-xs transition-all ', collapseIconClassName)}
                  style={{
                    transform: listOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                  }}
                  size={8}
                />
              </div>
            )}
            <div className={classNames('w-full', titleClassName)}>{title}</div>
            <div className='ml-1'>{titleSuffix}</div>
          </div>
          {listOpen && <div className='inline-flex items-center cursor-pointer'>{titleExtra}</div>}
        </div>
        <div
          className={classNames(
            {
              'border-l border-l-1  p-2': showContextBorder,
            },
            finalClassName.panelClassName,
            panelClassName,
            listOpen ? 'block' : 'hidden',
          )}
        >
          {showConnectionLine ? (
            <div className='flex relative'>
              <ConnectionLine className='h-full pl-[7px] absolute collapasebox-line' width={10} />
              <div
                className={classNames(
                  'flex-1 overflow-x-auto no-scroll-container overflow-y-hidden',
                  !noStyle && 'collapasebox-content',
                )}
              >
                {children}
              </div>
            </div>
          ) : (
            <div className={classNames(!noStyle && 'collapasebox-content')}>{children}</div>
          )}
        </div>
      </div>
    </>
  );
}
